// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/installation.css
// module id = 1280
// module chunks = 33